import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/UserModel';
import { UserProfile } from 'src/app/models/userProfile';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../../shared/user.service';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  selectedUserGroup: string;
  filteredUserListHeader:string;
  userGroupArr: string[] = ["L1", "L2", "L3", "L4"];

  selectedUserIndexArr: number[];
  selectedUser: string[];
  users: UserModel[];
  updatedUsersList: UserModel[];
  filteredUserList: UserModel[];
  name: string;

  newListFlag: boolean;
  invalidUserGroup: boolean;
  postResponse: UserModel[] = [];

  userId;
  user: UserProfile = new UserProfile();
  userMode = "On";
  library;



  constructor(private activateRout: ActivatedRoute, private http: HttpClient, private userService: UserService,private httpService:HttpService) { }

  ngOnInit() {
    this.selectedUserGroup = "";
    this.selectedUserIndexArr = [];
    this.selectedUser = [];
    this.updatedUsersList = [];
    this.filteredUserList = [];
    this.name = "";
    this.newListFlag = false;
    this.invalidUserGroup = false;

    this.httpService.getBasePath().then(
      res=>{
        this.getAllUsers();
      },err=>
      {
        console.log(err);
      });
    
    //  this.users=[{"userEmailId":"rahul@gmail.com","name":"Rahul Sah","userGroup":"L1"},{"userEmailId":"Karthik@gmail.com","name":"Karthik","userGroup":"L1"},{"userEmailId":"Shubrat@gmail.com","name":"Shubrat","userGroup":"L1"},{"userEmailId":"Shruti@gmail.com","name":"Shruti","userGroup":"L1"}
    //  ,{"userEmailId":"Dinesh@gmail.com","name":"Dinesh","userGroup":"L1"},{"userEmailId":"Hardik@gmail.com","name":"Hardik","userGroup":"L2"},{"userEmailId":"Jack@gmail.com","name":"Jack","userGroup":"L1"},{"userEmailId":"Chris@gmail.com","name":"Chris","userGroup":"L1"},{"userEmailId":"Nick@gmail.com","name":"Nick","userGroup":"L3"},{"userEmailId":"John@gmail.com","name":"John","userGroup":"L2"}];


    this.activateRout.params.subscribe(
      params => this.userId = params.userId
    )

    this.user.name = "Werner von Siemens"
  }

  getAllUsers() {
    this.userService.getAllUser().subscribe(
      (response: UserModel[]) => {
        console.log(response);
        this.users = response;
        this.filteredUserList = this.users.slice();
      },
      error => {
        console.log(error)
      }
    );
  }

  changeUserMode(userMode) {
    this.userMode = userMode === 'On' ? 'Off' : 'On';
  }


  search() {

    if (this.name == "") {
      this.filteredUserList = this.users.slice();
    }
    else {
      this.filteredUserList = this.users.filter(key => {
        return key.name.toLocaleLowerCase().match(this.name.toLocaleLowerCase());
      });
    }

  }

  userSelected(event, item, index) {

    if (this.selectedUserIndexArr.includes(index) == true) {
      this.selectedUserIndexArr.splice(this.selectedUserIndexArr.indexOf(index), 1);

      this.selectedUser = this.selectedUser.filter(user => {
        return user != item;
      });
    }
    else {

      this.selectedUserIndexArr.push(index);
      this.selectedUser.push(item);
    }
  }


  moveUser(userGroup:HTMLInputElement) {

    this.filteredUserListHeader=String(userGroup.value);
   
    let movingUsersGroupArr: string[] = [];
    this.updatedUsersList = [];

    this.postResponse = [];
    
    this.updatedUsersList = this.users.filter(user => {
      return user.userGroup == this.selectedUserGroup;
    });

    for (let i = 0; i < this.users.length; i++) {
      for (let j = 0; j < this.selectedUser.length; j++) {
        if (this.users[i].name == this.selectedUser[j]) {
          movingUsersGroupArr.push(this.users[i].userGroup);

          this.updatedUsersList.push({ "userEmailId": this.users[i].userEmailId, "name": this.users[i].name, "userGroup": this.selectedUserGroup });
          this.postResponse.push({ "userEmailId": this.users[i].userEmailId, "name": this.users[i].name, "userGroup": this.selectedUserGroup });
        }
      }
    }
    let counter = 0;
    for (let index = 0; index < movingUsersGroupArr.length; index++) {
      if (movingUsersGroupArr[index] == this.selectedUserGroup) {
        counter++;
        break;
      }

    }

    console.log(this.postResponse);
    if (counter !== 0) {
      this.invalidUserGroup = true;
      document.getElementById('my-modal').setAttribute('visible', 'true');
    }
    else {
      this.userService.moveUser(this.postResponse).subscribe(response => {
        this.newListFlag = true;
        this.invalidUserGroup = false;
        this.selectedUserIndexArr = [];
        this.selectedUser = [];
        this.getAllUsers();
      }, error => {
        console.log(error);
      });
    }

  }


}
